import { Plugin, registerPlugin } from '@capacitor/core';

export interface AppInfoPlugin extends Plugin {
  getAppId(): Promise<{ appId: string }>;
  getBuildInfo(): Promise<{ isDebugBuild: boolean }>;
}

const AppInfoPlugin = registerPlugin<AppInfoPlugin>('AppInfoPlugin');

export default AppInfoPlugin;
